export default __webpack_public_path__ + "static/media/char-rey.54e79968.jpg";